import { convertToGalleryItem } from "./convert-to-gallery-item.js";
const convertToGalleryItemList = ({
  items,
  relValue,
  anchorTarget,
  baseUrl
}) => {
  return items.map(
    (item, index) => convertToGalleryItem({ item, index, relValue, anchorTarget, baseUrl })
  );
};
export {
  convertToGalleryItemList
};
//# sourceMappingURL=convert-to-gallery-item-list.js.map
